<template>
    <div>
        <select-bar
                class="p-p-3 p-d-flex p-jc-between"
                v-on:updateGrade="updateGrade"
                v-on:updateSubject="updateSubject"
                v-on:updateReportName="updateReportName"
                v-on:updateOldReportName="updateOldReportName"
                v-on:updateReportType="updateReportType"
                v-on:updateRate="updateRate"
                ref="select-bar"
        ></select-bar>
        <h3 class="p-pr-3">{{titleHint}}</h3>
        <pupils-list
                class="p-p-3"
                :selectedGrade="selectedGrade"
                :selectedSubject=" selectedSubject"
                :selectedRate=" selectedRate"
                :selectedReportName="selectedReportName"
                :selectedOldReportName="selectedOldReportName"
                :selectedReportType="selectedReportType"
        ></pupils-list>
    </div>
</template>

<script>
import SelectBar from '@/views/report/gradeReport/gradeSelectBar.vue'
import PupilsList from '@/views/report/gradeReport/gradeList.vue'
import {mapState} from "vuex";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"

export default {
    name: "grade-report",
    components: {
        PupilsList,
        SelectBar
    },
    data() {
        return {
                gradeKey: 1,
            selectedGrade: null,
            selectedSubject: null,
            selectedReportName: null,
            selectedRate: null,
            selectedOldReportName: null,
            selectedReportType: null
        }
    },
    methods: {
        updateGrade(grade) {
            this.selectedGrade = grade
        },
        updateSubject(subject) {
            this.selectedSubject = subject
        },
        updateRate(rate) {
            this.selectedRate = rate
            this.gradeKey ++
        },
        updateReportName(name) {
            this.selectedReportName = name
        },
        updateOldReportName(oldName) {
            this.selectedOldReportName = oldName
        },
        updateReportType(report) {
            this.selectedReportType = report
        },
    },
    computed: {
        ...mapState([ "permissions"]),
        titleHint(){
          if (this.selectedReportType?.value === TOPICS_TYPE){
              return '90 - טוב מאוד, 80 - כמעט טוב מאוד, 70 - טוב, 60 - כמעט טוב, 50 - מספיק, 40 - כמעט מספיק, 30 - לא מספיק'
          } else if (this.selectedReportType?.value === BEHAVIORS_TYPE){
              return 'א\' - ראוי לשבח, ב\' - מניח את הדעת,  ג\' - טעון שיפור'
          }
        },
        canReport() {
            if (this.selectedReportType?.value !== NOTE_TYPE) {
                return this.selectedGrade === null || this.selectedSubject === null ||
                    this.selectedReportName === null
            } else {
                return this.selectedGrade === null ||
                    this.selectedReportName === null
            }
        }
    }
}
</script>

<style scoped>

</style>